import {
  EventContainer,
  PageHeaderControl,
  UserProfile
} from '@seims/shared'

export const UserProfileView = () => {
  return (
    <PageHeaderControl title={"Update Account Details"} showConfirmBack >
      <EventContainer>
        <UserProfile />
      </EventContainer>
    </PageHeaderControl>
  )
}
